import iso6391, { LanguageCode } from 'iso-639-1'

export const getLanguagesArray = () => {
  const languages = iso6391.getAllNames()
  return languages.map((language, index) => ({
    id: index + 1,
    name: language,
    code: iso6391.getCode(language),
  }))
}

export const getLanguageByCode = (code: string | undefined) => {
  const languagesArray = getLanguagesArray()
  let name = ''
  const errorResponse = {
    id: 0,
    name,
    code: '' as LanguageCode,
  }
  if (!languagesArray || !languagesArray.length)
    return { ...errorResponse, name: 'no language list' }
  if (!code) return { ...errorResponse, name: 'wrong language key' }

  const language = languagesArray.find((language) => language.code === code)
  if (!language) {
    if (code === 'ua') return { name: 'Ukrainian' }
    else return { ...errorResponse, name: 'language not defined' }
  }

  return language
}
